const FILE_CONTSTANTS = {
	download: "download",
	view: "view",
	delete: "delete",
};

export { FILE_CONTSTANTS };
